/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MetricCategory } from './MetricCategory';
import {
    MetricCategoryFromJSON,
    MetricCategoryFromJSONTyped,
    MetricCategoryToJSON,
    MetricCategoryToJSONTyped,
} from './MetricCategory';
import type { Resolution } from './Resolution';
import {
    ResolutionFromJSON,
    ResolutionFromJSONTyped,
    ResolutionToJSON,
    ResolutionToJSONTyped,
} from './Resolution';

/**
 * 
 * @export
 * @interface MetricRepresentation
 */
export interface MetricRepresentation {
    /**
     * 
     * @type {string}
     * @memberof MetricRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof MetricRepresentation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MetricRepresentation
     */
    unit: string;
    /**
     * 
     * @type {string}
     * @memberof MetricRepresentation
     */
    sourceUnit?: string;
    /**
     * 
     * @type {MetricCategory}
     * @memberof MetricRepresentation
     */
    category: MetricCategory;
    /**
     * 
     * @type {number}
     * @memberof MetricRepresentation
     */
    priority?: number;
    /**
     * 
     * @type {Resolution}
     * @memberof MetricRepresentation
     */
    minResolution: Resolution;
    /**
     * all features that are assigned to the metric
     * @type {Array<string>}
     * @memberof MetricRepresentation
     */
    licenseFeatures?: Array<string>;
    /**
     * Minimum value filter
     * @type {number}
     * @memberof MetricRepresentation
     */
    min?: number;
    /**
     * Maximum value filter
     * @type {number}
     * @memberof MetricRepresentation
     */
    max?: number;
    /**
     * 
     * @type {string}
     * @memberof MetricRepresentation
     */
    parentKey?: string;
    /**
     * this flag indicates if the metric should be available for data display or only for internal configuration purposes
     * @type {boolean}
     * @memberof MetricRepresentation
     */
    internal?: boolean;
    /**
     * this flag indicates if the metric should be available for widgets
     * @type {boolean}
     * @memberof MetricRepresentation
     */
    inactive?: boolean;
}



/**
 * Check if a given object implements the MetricRepresentation interface.
 */
export function instanceOfMetricRepresentation(value: object): value is MetricRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('minResolution' in value) || value['minResolution'] === undefined) return false;
    return true;
}

export function MetricRepresentationFromJSON(json: any): MetricRepresentation {
    return MetricRepresentationFromJSONTyped(json, false);
}

export function MetricRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetricRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'unit': json['unit'],
        'sourceUnit': json['sourceUnit'] == null ? undefined : json['sourceUnit'],
        'category': MetricCategoryFromJSON(json['category']),
        'priority': json['priority'] == null ? undefined : json['priority'],
        'minResolution': ResolutionFromJSON(json['minResolution']),
        'licenseFeatures': json['licenseFeatures'] == null ? undefined : json['licenseFeatures'],
        'min': json['min'] == null ? undefined : json['min'],
        'max': json['max'] == null ? undefined : json['max'],
        'parentKey': json['parentKey'] == null ? undefined : json['parentKey'],
        'internal': json['internal'] == null ? undefined : json['internal'],
        'inactive': json['inactive'] == null ? undefined : json['inactive'],
    };
}

export function MetricRepresentationToJSON(json: any): MetricRepresentation {
    return MetricRepresentationToJSONTyped(json, false);
}

export function MetricRepresentationToJSONTyped(value?: MetricRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'unit': value['unit'],
        'sourceUnit': value['sourceUnit'],
        'category': MetricCategoryToJSON(value['category']),
        'priority': value['priority'],
        'minResolution': ResolutionToJSON(value['minResolution']),
        'licenseFeatures': value['licenseFeatures'],
        'min': value['min'],
        'max': value['max'],
        'parentKey': value['parentKey'],
        'internal': value['internal'],
        'inactive': value['inactive'],
    };
}

